import * as logsAPI from '@opentelemetry/api-logs';

export const LOGGER_NAME = 'nmui4d-logger';

export interface ILogger {
    debug: (message?: unknown, ...args: unknown[]) => void;
    info: (message?: unknown, ...args: unknown[]) => void;
    warn: (message?: unknown, ...args: unknown[]) => void;
    error: (message?: unknown, ...args: unknown[]) => void;
}

export class OpenTelemetryLoggingLogger implements ILogger {
    private otelLogger: logsAPI.Logger;

    public constructor(otelLogger: logsAPI.Logger) {
        this.otelLogger = otelLogger;
    }

    private log(severityNumber: logsAPI.SeverityNumber, message?: unknown, ...args: unknown[]) {
        this.otelLogger.emit({
            severityNumber: severityNumber,
            severityText: logsAPI.SeverityNumber[severityNumber],
            body: message as logsAPI.AnyValue | undefined,
            attributes: {
                // 'log.type': 'LogRecord',
                args: args
                    ? JSON.stringify(
                          args.map(x => {
                              return { value: x as logsAPI.AnyValue };
                          }),
                      )
                    : undefined,
            },
        });
    }

    public debug(message?: unknown, ...args: unknown[]) {
        this.log(logsAPI.SeverityNumber.DEBUG, message, ...args);
    }

    public info(message?: unknown, ...args: unknown[]) {
        this.log(logsAPI.SeverityNumber.INFO, message, ...args);
    }

    public warn(message?: unknown, ...args: unknown[]) {
        this.log(logsAPI.SeverityNumber.WARN, message, ...args);
    }

    public error(message?: unknown, ...args: unknown[]) {
        this.log(logsAPI.SeverityNumber.ERROR, message, ...args);
    }
}

export class ConnectionCheckingLogger implements ILogger {
    private delegatee: ILogger;
    private isTargetURLInvalid = false;

    public constructor(delegatee: ILogger, targetUrl: URL) {
        this.delegatee = delegatee;
        void this.checkTargetAvailabilityAsync(targetUrl);
    }

    private async checkTargetAvailabilityAsync(targetURL: URL) {
        try {
            await fetch(targetURL, { method: 'POST' });
        } catch (error) {
            this.isTargetURLInvalid = true;
            console.error(
                `Failed to connect to logging backend '${targetURL}', disabling log transmission for this session.`,
                error,
            );
        }
    }

    public debug(message?: unknown, ...args: unknown[]) {
        if (this.isTargetURLInvalid) {
            return;
        }
        this.delegatee.debug(message, ...args);
    }

    public info(message?: unknown, ...args: unknown[]) {
        if (this.isTargetURLInvalid) {
            return;
        }
        this.delegatee.info(message, ...args);
    }

    public warn(message?: unknown, ...args: unknown[]) {
        if (this.isTargetURLInvalid) {
            return;
        }
        this.delegatee.warn(message, ...args);
    }

    public error(message?: unknown, ...args: unknown[]) {
        if (this.isTargetURLInvalid) {
            return;
        }
        this.delegatee.error(message, ...args);
    }
}
